<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    >
    </zx-table>
  </div>
</template>

<script>
import * as cronLogs from "@/api/logs/cronLogs.js";
import * as plan from "@/api/plan/plan.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        run_file: {
          field: "run_file",
          label: "执行文件",
          type: "select",
          options: plan.getCronFileList.r()
        },
        date: {
          field: "date",
          label: "开始时间",
          type: "datetimerange",
          attrs: {
            valueFormat: "yyyy-MM-dd-hh:mm:ss",
            pickerOptions: {
              shortcuts: [
                {
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      searchData: {},
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "计划",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "run_file",
            // 列名
            label: "执行文件",
            hide: true
          },
          {
            prop: "run_date",
            // 列名
            label: "开始时间",
            hide: true
          },
          {
            prop: "finish_date",
            // 列名
            label: "完成时间",
            hide: true
          },
          {
            prop: "error",
            // 列名
            label: "执行日志",
            hide: true
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 搜索提交
    searchSubmit(e) {
      this.searchData = e;
      if (e.date) {
        let date = {
          start_time: e.date[0],
          end_time: e.date[1]
        };
        delete e.date;
        this.searchData = {
          ...e,
          ...date
        };
      }
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      cronLogs.getCronLogist.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
